import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { COMPANY_INFO } from '../constants/company';

// Configuración de iconos de Leaflet
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

if (L.Icon && L.Icon.Default) {
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
  });
}

// Icono personalizado premium
const iconCapriata = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const sucursales = [
  { nombre: "Casa Central", direccion: "Gomila 260", coords: [-38.37408, -60.27437] },
  { nombre: "Capriata Especialidades", direccion: "Pedro N Carrera 60", coords: [-38.38186, -60.27043] },
  { nombre: "Capriata al Paso", direccion: "Maipú 215", coords: [-38.38155, -60.27400] },
  { nombre: "Capriata Market", direccion: "Istilart J. B. 998", coords: [-38.37158, -60.26360] }
];

const mapaBounds = L.latLngBounds(sucursales.map((suc) => suc.coords));

const LandingPage = () => {
  // Sin estado scrolled ya que el header fue removido


  return (
    <div className="contenedor-landing">


      {/* Sección de Portada */}
      <section className="portada">
        <div className="contenido-portada">
          <h1 className="logo-portada">{COMPANY_INFO.NAME}</h1>
          <div className="barra-italiana">
            <span className="barra-verde"></span>
            <span className="barra-blanca"></span>
            <span className="barra-roja"></span>
          </div>
          <p className="eslogan-portada">{COMPANY_INFO.SLOGAN}</p>
        </div>
      </section>

      {/* Sección de Historia */}
      <section className="seccion">
        <div className="rejilla-historia">
          <div className="contenido-historia">
            <h2>Nuestra Historia</h2>
            <p>
              Con la llegada de inmigrantes de diversos países a esta zona, sobre la primera década del siglo XX,
              arribaron a Tres Arroyos los integrantes de una familia proveniente del Piamonte, Italia.
            </p>
            <p>
              Cuatro hermanos traían consigo no sólo recetas vinculadas tanto a su lugar de origen como a las tradiciones familiares,
              sino también el conocimiento necesario para dedicarse de lleno a la crianza de cerdos y la factura de embutidos y chacinados.
            </p>
            <p>
              En 1954, los hijos del pionero don Césare decidieron ampliar la planta de elaboración, dotándola de tecnología y medidas de seguridad
              para la fabricación de alimentos cuya calidad es reconocida en una amplia región.
            </p>
            <p>
              Hoy, los productos que llevan su sello son sinónimo de la calidad artesanal de aquellas recetas tradicionales de los abuelos italianos,
              y de los más altos estándares de desarrollo empresario.
            </p>
          </div>
          <div className="imagen-historia">
            <img src="/images/media__1771953273940.png" alt="Historia Capriata" />
          </div>
        </div>
      </section>

      {/* Sección de Productos */}
      <section className="seccion seccion-productos">
        <div className="container">
          <h2 className="titulo-seccion">Nuestros Productos</h2>
          <div className="rejilla-productos">
            <div className="tarjeta-producto">
              <div className="tarjeta-imagen" style={{ backgroundImage: "url('/images/media__1771948158929.jpg')" }}></div>
              <div className="tarjeta-contenido">
                <h3>Cortes & Frescos</h3>
                <p>
                  Elaboramos nuestros productos a partir de cerdos enteros, realizando cortes frescos y preparaciones
                  artesanales como chorizos frescos, salchichas, morcillas, milanesas y brochettes.
                </p>
              </div>
            </div>
            <div className="tarjeta-producto">
              <div className="tarjeta-imagen" style={{ backgroundImage: "url('/images/media__1771948158946.jpg')" }}></div>
              <div className="tarjeta-contenido">
                <h3>Clásicos de Siempre</h3>
                <p>
                  Chorizos secos, salamines, lomo ahumado y patas de jamón, elaborados con técnicas tradicionales
                  y sabores que nos identifican generacionalmente.
                </p>
              </div>
            </div>
            <div className="tarjeta-producto">
              <div className="tarjeta-imagen" style={{ backgroundImage: "url('/images/media__1771948158957.jpg')", backgroundPosition: "bottom" }}></div>
              <div className="tarjeta-contenido">
                <h3>Boutique</h3>
                <p>
                  Para complementar la experiencia, ofrecemos una selección de productos de calidad:
                  quesos, fiambres, conservas, dulces, aceites de oliva y snacks seleccionados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Acción Boutique */}
      <section className="accion-boutique" style={{ backgroundImage: "linear-gradient(rgba(10, 10, 10, 0.85), rgba(10, 10, 10, 0.85)), url('/images/media__1771948158998.jpg')" }}>
        <div className="contenido-boutique">
          <h2>Experiencia Real. Sabor Auténtico.</h2>
          <p style={{ color: 'var(--color-texto-atenuado)', marginBottom: '2rem', maxWidth: '700px', margin: '0 auto 2rem' }}>
            En cada sucursal vas a encontrar productos frescos, artesanales y seleccionados con el mismo criterio:
            calidad real y sabor auténtico.
          </p>
        </div>
      </section>

      {/* Sección de Sucursales */}
      <section className="seccion seccion-sucursales">
        <h2 className="titulo-seccion">Sucursales</h2>
        <div className="rejilla-sucursales">
          <div className="lista-sucursales">
            {sucursales.map((suc, idx) => (
              <div key={idx} className="item-sucursal">
                <LocationOnIcon className="icono-sucursal" style={{ color: '#CD212A' }} />
                <div>
                  <p className="direccion">{suc.direccion}</p>
                  <p className="ciudad">Tres Arroyos, BA</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mapa-contenedor leaflet-map-wrapper">
            <MapContainer
              bounds={mapaBounds}
              boundsOptions={{ padding: [40, 40] }}
              style={{ height: '450px', width: '100%', borderRadius: '16px' }}
              scrollWheelZoom={false}
              attributionControl={false}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {sucursales.map((suc, idx) => (
                <Marker key={idx} position={suc.coords} icon={iconCapriata}>
                  <Popup>
                    <div className="popup-capriata">
                      <strong>{suc.nombre}</strong><br />
                      {suc.direccion}
                    </div>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
            <div className="minimal-attribution">© OpenStreetMap contributors</div>
          </div>
        </div>
      </section>

      {/* Sección de Contacto */}
      <section className="seccion-contacto">
        <div className="contenido-contacto">
          <h2 className="titulo-contacto">Contactanos</h2>
          <div className="iconos-contacto">
            <a href={COMPANY_INFO.SOCIAL.INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="enlace-contacto">
              <InstagramIcon sx={{ fontSize: 48 }} />
              <span>{COMPANY_INFO.SOCIAL.INSTAGRAM}</span>
            </a>
            <a href={`mailto:${COMPANY_INFO.EMAILS.CONTACT}`} className="enlace-contacto">
              <EmailIcon sx={{ fontSize: 48 }} />
              <span>{COMPANY_INFO.EMAILS.CONTACT}</span>
            </a>
          </div>
        </div>
      </section>

      {/* Pie de Página */}
      <footer className="pie-pagina">
        <p>© {new Date().getFullYear()} {COMPANY_INFO.NAME}. {COMPANY_INFO.LOCATION}.</p>
        <p style={{ fontSize: '0.8rem', opacity: 0.5, marginBottom: '2rem' }}>{COMPANY_INFO.FULL_SLOGAN}</p>
        <div className="footer-links">
          <Link to="/login" className="enlace-login-footer">Iniciar sesión</Link>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;

